{
  "addNewAccount": "Add new account",
  "clickSubmitToContinue": "Click Submit to continue",
  "thatsAllWeNeed": "That's all we need",
  "errorCompleteStep": "Please complete the current step in order to proceed.",
  "back": "Back",
  "next": "Next",
  "cancel": "Cancel",
  "submit": "Submit",
  "pressNextToContinue": "Press >Next< to continue.",
  "pressSubmitToFinish": "Press >Submit< to finish.",
  "currentBalance": "Current balance",
  "common": {
    "connectedAccounts": {
      "title": "Which accounts do you use?",
      "subtitle": "Link the bank accounts that fund or receive this pension’s cash flows.",
      "whenIBuy": "To {{buyOrSellText}}, I...",
      "existingAccount": "... use existing bank accounts",
      "existingAccountSelect": "Select one or more accounts",
      "createAccountLater": "... use a bank account which I will set up later",
      "createAccountLaterDescription": "Once you set up that account, remember to update the linked account in this {{categorySingle}} account."
    }
  },
  "D1": {
    "accountType": "Account type",
    "whatKindOfAccount": "What kind of account do you want to add? Select the option which is the best match for your account",
    "products": {
      "savings-account-giro": "Bank account for your daily expenditure and spending. You are able to withdraw and deposit money at any time.",
      "savings-account-tagesgeld": "A savings account where - in theory - you get slightly more interest than with your Girokonto, but are often limited as to when you can withdraw.",
      "savings-account-generic": "Bank account for your daily expenditure and spending. You are able to withdraw and deposit money at any time.",
      "time-deposit-festgeld": "Bank deposit which you cannot withdraw until it reaches its maturity date.",
      "time-deposit-generic": "Bank deposit which you cannot withdraw until it reaches its maturity date."
    }
  },
  "D2": {
    "automaticOrManual": "Automatic or manual updates",
    "updateAutomatically": "Would you like us to get your data automatically? You can change it later.",
    "automatic": {
      "label": "Automatic synchronisation",
      "description": "We will set up a secure connection to your bank and take care of retrieving the lastest transactions. You may need to use your bank app to confirm that process. Manual import is still possible."
    },
    "manual": {
      "label": "Manual updates",
      "description": "You can also use our intelligent data import to easily transfer data about your accounts. All you need to do is download the transactions from your bank website and upload them here."
    }
  },
  "D3": {
    "bank": "bank",
    "banks": "banks",
    "aBank": "a bank",
    "yourBank": "your bank",
    "broker": "broker",
    "brokers": "brokers",
    "aBroker": "a broker",
    "yourBroker": "your broker",
    "selectCountry": "Select country",
    "accountCountry": "Account country",
    "accountCountryBody": "In which country is your account (or the provider of your account) located?",
    "selectCountryFirst": "Select account country above first.",
    "select": "Select {{yourInstitutionType}}",
    "retrievingInstitutions": "We are preparing the list...",
    "nothingFound": "We cannot retrieve data from {{yourInstitutions}} in this country yet. You can add a bank manually by clicking the button below.",
    "noSlots": "You have reached the limit of foreign {{yourInstitutions}} that we can provide automatic updates for. You can add a bank manually by clicking the button below.",
    "noResultsFound": "No results found.",
    "findYourBank": "Find {{yourInstitutionType}} in the list to synchronise your data automatically.",
    "cannotFind": "If you can't find {{yourInstitutionType}} here, automatic data synchronisation is not yet possible. ",
    "addManualAccount": "Add {{anInstitutionType}} manually",
    "thisAccountManual": "This account will not be synchronised automatically. Data can be imported from a file or input manually.",
    "thisAccountManual2": "To enable automatic synchronisation, please select {{anInstitutionType}} in the list above.",
    "thisAccountManual3": "Press >Next< to continue.",
    "intelligentImport": "Find your bank in the list so that our intelligent import knows what data structure to expect.",
    "couldNotFindAnything": "We couldn't find anything with that term. Please try again.",
    "youHaveSelected": "You have selected",
    "yourSelection": "Your selection",
    "details": "Details of the selected bank",
    "search": "Search"
  },
  "D4": {
    "account": "Account",
    "accountInfo": "Account information",
    "accountInfoManual": "Please provide some information about your account.",
    "accountInfoAutomatic": "We have retrieved this information about your account from your bank.",
    "accountInfoAutomatic2": " Uncheck >This account will be created< to stop it from being created in Monestry.",
    "connectedCashAccount": "Connected cash account",
    "whichCashAccount": "Which cash account do you use to buy and sell securities?",
    "whyDoWeAsk": "Why do we need a connected cash account?",
    "whyDoWeAskAnswer": "We calculate return from investment and income from capital based on data from cash accounts, which the stocks transactions are deducted from or credited to.",
    "notHaveAccount": "What if I don't have a separate cash account?",
    "notHaveAccountAnswer": "If your broker handles all cash transactions, we will create a 'technical account' for you so that you have a better picture of all the cash operations - just pick that option on the bottom of the form.",
    "whenIBuy": "When I buy securities, the money...",
    "existingAccount": "... is deducted from an existing bank account",
    "existingAccountSelect": "Select that bank account",
    "createTechnicalAccount": "... is deducted from a cash account at my brokerage firm",
    "createTechnicalAccountCurrency": "In what currency is this cash account?",
    "createAccountLater": "... is deducted from a bank account which I will set up later",
    "createAccountLaterDescription": "Once you set up that account, remember to update the linked account in this account.",
    "gettingAdditionalAccountInformation": "Getting additional account information...",
    "providerAllAccountsAdded": "No new accounts found. All accounts have been added.",
    "accountName": {
      "label": "Account name",
      "tooltip": "What name would you like to see for this account in the system?",
      "error": "Please enter a designation for this account."
    },
    "baseCurrency": {
      "label": "Base currency",
      "tooltip": "What currency does this account use?"
    },
    "iban": {
      "label": "IBAN",
      "tooltip": "This account's IBAN (account number)",
      "placeholder": "DE12345678901234567890"
    },
    "bic": {
      "label": "BIC",
      "tooltip": "International bank code (called >BIC<) for the bank where this account is at. Up to 11 characters long. Used to identify a bank in an international setting."
    },
    "bankName": {
      "label": "Bank name",
      "tooltip": "Name of the bank where this account is at.",
      "placeholder": "Sparkasse Bielefeld"
    },
    "brokerName": {
      "label": "Provider name",
      "tooltip": "Which broker is this account with?",
      "placeholder": "DepotX"
    },
    "accountNo": {
      "label": "Account number",
      "tooltip": "What is the number of your brokerage account?",
      "placeholder": "C12345678"
    },
    "isImported": {
      "label": "This account will be created.",
      "tooltip": "Untick this box to stop this account from being created.",
      "error": "You can only create {{num}} more accounts on your current plan.",
      "error1": "You can only create one more account on your current plan.",
      "error0": "You cannot create any more accounts on your current plan."
    },
    "connectedDepositMode": {
      "error": "Please choose how to link a deposit account to this one."
    }
  },
  "R1": {
    "accountInfo": "Account information",
    "provideInfo": "Provide some information about your property.",
    "oneAccount": "One account covers exactly one property - if you own more than one, create more accounts.",
    "whyDoWeAsk": "Why do we want to know?",
    "whyDoWeAskAnswer": "These are all the parameters used to calculate your property's value.",
    "doIHaveToFillThemAllOut": "Do I have to fill out all those fields?",
    "doIHaveToFillThemAllOutAnswer": "No, but the more information you provide, the better the automatic valuation will be.",
    "name": {
      "label": "Property name",
      "tooltip": "What name would you like to see for this property in the app?",
      "placeholder": "Apartment in Bielefeld",
      "error": "Please enter your designation for this property."
    },
    "originalPrice": {
      "label": "Purchase price",
      "tooltip": "How much did it cost you? You can change it later.",
      "placeholder": "456000",
      "error": "If purchase date is provided, we will also need a purchase price for this property. You can change it later."
    },
    "date": {
      "label": "Purchase date",
      "tooltip": "Since when do you own it? You can change it later.",
      "placeholder": "2015-05-15",
      "error": "If purchase price is entered, we will also need a purchase date for this property. You can change it later."
    },
    "automaticUpdate": {
      "label": "Update value automatically?",
      "tooltip": "Turn it on to allow automatic updates for this property's value. You can change it later.",
      "disabled": "Automatic value updates for your account are in use for other properties or not available."
    },
    "currency": {
      "label": "Currency",
      "tooltip": "What currency would you like to track this property's value in? Typically this is the currency of the country where the property is located. We will automatically convert that value to your base currency."
    },
    "kindOfProperty": "What kind of property is this?",
    "type": {
      "label": "Property type",
      "apartment": "Apartment",
      "house": "House"
    },
    "streetAddress": {
      "label": "Street and number",
      "tooltip": "Where is your property located?",
      "placeholder": "Hochstr. 12"
    },
    "zip": {
      "label": "Postal code",
      "tooltip": "What postal code does your property have?",
      "placeholder": "33602"
    },
    "city": {
      "label": "City / town",
      "tooltip": "What city / town / village is your property located at?",
      "placeholder": "Bielefeld"
    },
    "country": {
      "label": "Country",
      "tooltip": "What country is your property located in?",
      "placeholder": "Germany"
    },
    "livingArea": {
      "label": "Floor area",
      "tooltip": "How big is your property (in square meters)?",
      "placeholder": "88"
    },
    "rooms": {
      "label": "Rooms",
      "tooltip": "How many rooms does your property have?",
      "placeholder": "3"
    },
    "lotArea": {
      "label": "Lot area",
      "tooltip": "How big is the lot your property is located on (in square meters)?",
      "placeholder": "450"
    },
    "constructionYear": {
      "label": "Construction year",
      "tooltip": "When was your property built?",
      "placeholder": "2010"
    },
    "parking": {
      "label": "Private parking included?"
    }
  },
  "S1": {
    "accountInformation": "Account information",
    "description": "Provide some information about your account.",
    "whyDoWeAsk": "Why do we ask?",
    "whyDoWeAskAnswer": "We use data like account number, username, connected cash account to link cash transactions with your stock market transactions. You don&apos;t have to provide them, but our system may not be able to link the appropriate transactions and you may need to do that manually.",
    "name": {
      "label": "Account name",
      "tooltip": "What name would you like to see for this account in this app?",
      "placeholder": "DepotX brokerage account",
      "error": "Please enter your designation for this account."
    },
    "brokerName": {
      "label": "Provider name",
      "tooltip": "Which broker is this account with?",
      "placeholder": "DepotX"
    },
    "accountNo": {
      "label": "Account number",
      "tooltip": "What is the number of your brokerage account?",
      "placeholder": "C12345678"
    },
    "username": {
      "label": "Your username for this brokerage account",
      "tooltip": "The username you use to log in to this account.",
      "placeholder": "ab12345678"
    }
  },
  "S2": {
    "connectedCashAccount": "Connected cash account",
    "whichCashAccount": "Which cash account do you use to buy and sell securities?",
    "whyDoWeAsk": "Why do we need a connected cash account?",
    "whyDoWeAskAnswer": "We calculate return from investment and income from capital based on data from cash accounts, which the stocks transactions are deducted from or credited to.",
    "notHaveAccount": "What if I don't have a separate cash account?",
    "notHaveAccountAnswer": "If your broker handles all cash transactions, we will create a 'technical account' for you so that you have a better picture of all the cash operations - just pick that option on the bottom of the form.",
    "whenIBuy": "When I buy securities, the money...",
    "existingAccount": "... is deducted from an existing bank account",
    "existingAccountSelect": "Select that bank account",
    "createTechnicalAccount": "... is deducted from a cash account at my brokerage firm",
    "createTechnicalAccountCurrency": "In what currency is this cash account?",
    "createAccountLater": "... is deducted from a bank account which I will set up later",
    "createAccountLaterDescription": "As soon as the bank account is added, open the detail view of this account and link the bank account there."
  },
  "loans": {
    "given": "Loan given",
    "taken": "Loan taken",
    "provideSomeParameters": "Please provider some parameters which we will use to simulate future loan payments. You don't need to enter past changes, as they are reflected in the loan account transactions already.",
    "loanAmount": {
      "label": "Loan amount",
      "tooltip": "Enter the total amount of the loan (principal / capital only).",
      "error": "Please enter the loan amount."
    },
    "direction": {
      "label": "Loan taken or given?",
      "tooltip": "If you borrowed money, select 'taken'; otherwise select 'given'.",
      "error": "Please mark if this is a taken or given loan."
    },
    "period": {
      "month": "month",
      "quarter": "quarter",
      "year": "year",
      "label": "Installments repaid every",
      "placeholder": "Select period",
      "tooltip": "How often do you pay loan installments?",
      "error": "Please select the installment period."
    },
    "interestRate": {
      "text": "Interest rate and in some cases the installment amount may change over time. Use >Advanced< button if you wish to enter those changes now. You can also do it later.",
      "label": "Interest rate (%)",
      "tooltip": "Enter the annual interest rate for the loan.",
      "error": "Please enter the annual interest rate in %."
    },
    "endDate": {
      "text": "If you enter an end date, the simulation will calculate last installment as the entire outstanding debt (also know as a balloon payment or Restschuld). If you plan to take out a different loan, enter the end date here and create another loan account starting on the month of the last installment of this loan.",
      "label": "Loan contract end date",
      "tooltip": "When does the loan contract end? You can leave this field empty.",
      "error": "It must be a future date"
    },
    "calculateUntilEnd": {
      "label": "Simulate until completely repaid",
      "tooltip": "If you want to simulate the loan payments until the end of the loan term, select this option."
    },
    "advanced": "Advanced",
    "installmentCalc": "Is the loan installment the same every time? Select 'Annuity'. Is it lower every time (you pay back a fixed amount of capital every month with changing interest)? Select 'Fixed Principal'. If you only pay back the interest (capital is repaid at term's end), select 'Interest Only'. Don't forget to enter an end date so that we can calculate the last installment.",
    "type": {
      "annuity": "Annuity",
      "fixedPrincipal": "Fixed principal",
      "interestOnly": "Interest only",
      "label": "Installment type",
      "tooltip": "How is your installment calculated? See note on the left for explanation.",
      "error": "Please select the installment type."
    },
    "byInstallentAmount": "Enter the amount of each installment (annuity).",
    "byTilgungsrate": "Enter the percentage of the loan amount to be repaid annually ('Tilgunsrate').",
    "annuitySubtype": {
      "error": "Please select an option."
    },
    "annuitySubtypeAmount": {
      "label": "Installment amount",
      "tooltip": "Enter the amount for your fixed installment.",
      "error": "Please enter the amount for your fixed installment."
    },
    "annuitySubtypeTilgung": {
      "label": "Annual repayment rate (Tilgung) (%)",
      "tooltip": "Specify the percentage of the loan amount to be repaid annually.",
      "error": "Please enter the percentage of the loan amount to be repaid every year."
    },
    "fixedPrincipalSubtype": {
      "error": "Please select an option."
    },
    "byPrincipalRepaid": "Enter the amount of principal (capital) to be repaid in each period.",
    "fixedPrincipalSubtypeAmount": {
      "label": "Principal amount",
      "tooltip": "Enter the principal (capital) amount to be repaid in each period.",
      "error": "Please enter the amount to be repaid in each period."
    },
    "fixedPrincipalSubtypeTilgung": {
      "label": "Annual repayment rate (Tilgung) (%)",
      "tooltip": "Specify the percentage of the loan amount to be repaid annually.",
      "error": "Please enter the percentage of the loan amount to be repaid every year."
    },
    "connectedDepositAccount": "In order to track the loan payouts and payments, we need to know which account the money is coming from and going to. If you use more than one, you can add the other account later.",
    "connectedDepositMode": {
      "error": "Please choose how you'll connect the deposit account."
    },
    "existingAccount": "Existing account",
    "existingAccountSelect": "Select an existing account",
    "createAccountLater": "Create account later",
    "createAccountLaterDescription": "You can choose to connect a deposit account later.",
    "loanProject": "You can see the simulated future payments in Projects. If you already have a Project for this loan, select it here. If not, mark >Create new project<.",
    "connectedProjectId": {
      "label": "Connected project",
      "tooltip": "Select the project associated with this loan."
    },
    "projectCreateNew": "Create a new project",
    "bereitstellungszinsen": {
      "text": "Interest before complete loan payout (Bereitstellungszinsen)",
      "label": "Intial interest rate (%)",
      "tooltip": "Enter the interest rate charged on the undrawn portion of the loan."
    },
    "bereitstellungszinsenSinceDate": {
      "label": "Beginning on",
      "tooltip": "Specify the date from which the commitment interest will be calculated."
    },
    "interestAfterTerm": {
      "text": "Apply new interest after loan contract end date. This will enable 'simulate until completely repaid' option above and apply this interest rate from the specified date.",
      "label": "Interest after contract ends (%)",
      "tooltip": "Enter the interest rate applicable after the initial term ends."
    },
    "interestAfterTermSinceDate": {
      "label": "Beginning on",
      "tooltip": "Indicate the start date for the post-term interest rate."
    },
    "interestCalculationCutoff": "Does your bank calculate your installment on month beginning or on month end? If at month end, then all the extra repayments made in that month will already be reflected in the installment's interest to principal ratio. If month beginning, then they will only be reflected the following month.,",
    "interestCalcMonthEnd": {
      "label": "Interest is calculated at month end",
      "tooltip": "Toggle whether to calculate interest at the end of each month."
    }
  },
  "pension": {
    "wizardSteps": {
      "newAccount": {
        "title": "Add new account",
        "subtitle": "Tell us basic information about this pension product so we can set up the workflow for you."
      },
      "selectProduct": {
        "title": "What product is this?",
        "subtitle": "Choose the product type or template that best matches what you’re adding."
      },
      "contributions": {
        "title": "How do you pay for it?",
        "subtitle": "Describe how and when contributions are made so we can project the balance."
      },
      "payouts": {
        "title": "How will your pension be paid out?",
        "subtitle": "Let us know the payout cadence and rules for the retirement phase."
      },
      "payoutsAmount": {
        "title": "How much will you receive?",
        "subtitle": "Enter one or more future payouts. You will find them in the latest statement you received from your pension provider. Pick one to be used for net worth calculations.",
        "useThisCta": "Use this quote",
        "useThisActive": "✔️ Used for calculations",
        "payoutsAmountUseSpecialQuoteValidation": "Select which quote to use"
      },
      "connectedAccount": {
        "title": "Which accounts do you use?",
        "subtitle": "Link the bank accounts that fund or receive this pension’s cash flows.",
        "buyOrSellText": "pay contributions or receive payouts on this pension product"
      }
    },
    "provideInfo": "Please provide a few details about your pension account.",
    "whyDoWeAsk": "Why do we want to know?",
    "whyDoWeAskAnswer": "We use these parameters to calculate your pension's value and simulate future payments.",
    "doIHaveToFillThemAllOut": "Do I have to fill out all those fields?",
    "doIHaveToFillThemAllOutAnswer": "We need some information to provide meaningful information to you. Fields marked 'optional' are not strictly required, but will be used to calculate other useful data for you.",
    "payoutsAmountValidation": "Please enter at least one payout amount",
    "payoutsAmountUseSpecialQuoteValidation": "Select which quote to use",
    "useATemplate": "Use a template!",
    "useATemplateAnswer": "The most common pension products have already been configured for you - just select one from the list.",
    "yourPensionContributions": "Contributions - when I save",
    "yourPensionPayouts": "Payouts - when I retire",
    "whenIBuy": "When I buy securities, the money...",
    "existingAccount": "... is deducted from an existing bank account",
    "existingAccountSelect": "Select that bank account",
    "createAccountLater": "... is deducted from a bank account which I will set up later",
    "createAccountLaterDescription": "Once you set up that account, remember to update the linked account in this account.",
    "product": {
      "label": "Product type",
      "tooltip": "Select the type of pension product you have. If you can't find it in the list, select 'Custom'.",
      "pension-drv": {
        "name": "State pension (DRV)",
        "description": "State pension (e.g. Deutsche Rentenversicherung) is state-managed pension scheme in Germany. Your employer and you pay contributions, and the pension is paid out by the state. Pension payouts are generally taxable and get increased over time."
      },
      "pension-betriebliche": {
        "name": "Company pension (Betriebliche Rente)",
        "description": "Company pension is a pension scheme offered by your employer. Contributions are deducted from your salary before taxes, sometimes with your employer contribution. Your pension is taxed when paid out."
      },
      "pension-riester": {
        "name": "Riester pension",
        "description": "Riester pension is a state-subsidised pension scheme in Germany. Contributions are tax-deductible and the pension is taxed when paid out. The minimal payout is guaranteed to be at least equal to sum of your contributions."
      },
      "pension-ruerup": {
        "name": "Rürup pension",
        "description": "Rürup pension is a state-subsidised pension scheme in Germany. Contributions are tax-deductible and the pension is taxed when paid out."
      },
      "custom": {
        "name": "Custom",
        "description": "Configure any other product."
      },
      "selected": "Selected"
    }
  },
  "objectsOfValue": {
    "accountInfo": "Add new account",
    "provideInfo": "Please provide a few details about your pension account.",
    "whyDoWeAsk": "Why do we want to know?",
    "whyDoWeAskAnswer": "We use these parameters to calculate your pension's value and simulate future payments.",
    "whenIBuy": "When I buy objects of value, the money...",
    "existingAccount": "... is deducted from an existing bank account",
    "existingAccountSelect": "Select that bank account",
    "createAccountLater": "... is deducted from a bank account which I will set up later",
    "createAccountLaterDescription": "Once you set up that account, remember to update the linked account in this account."
  },
  "metals": {
    "accountInfo": "Add new account",
    "provideInfo": "You can decide how you want to structure your precious metals assets by organising them into accounts. You can create multiple accounts for different types of metals or different storage locations.",
    "whenIBuy": "When I buy precious metals, the money...",
    "existingAccount": "... is deducted from an existing bank account",
    "existingAccountSelect": "Select that bank account",
    "createAccountLater": "... is deducted from a bank account which I will set up later",
    "createAccountLaterDescription": "Once you set up that account, remember to update the linked account in this account."
  },
  "unlistedShares": {
    "accountInfo": "Add new account",
    "provideInfo": "Please provide a few basic details to get started. Once the account has been created, you will be able to add more investments and valuations.",
    "whenIBuy": "When I make investments in my company, the money...",
    "existingAccount": "... is transferred from an existing bank account",
    "existingAccountSelect": "Select that bank account",
    "createAccountLater": "... is transferred from a bank account which I will set up later",
    "createAccountLaterDescription": "Once you set up that account, remember to update the linked account in this account.",
    "fxRate": "Exchange rate: {{fxRate}}.",
    "apply": "Apply"
  },
  "crypto": {
    "accountInfo": "Add new account",
    "provideInfo": "Please provide some basic information about your account. Once the account is created, you can add your actual cryptocurrencies.",
    "whenIBuy": "When I buy crypto assets, the money...",
    "existingAccount": "... is deducted from an existing bank account",
    "existingAccountSelect": "Select that bank account",
    "createAccountLater": "... is deducted from a bank account which I will set up later",
    "createAccountLaterDescription": "Once you set up that account, remember to update the linked account in this account.",
    "createTechnicalAccount": "... is deducted from a cash account at my brokerage / exchange",
    "createTechnicalAccountTooltip": "If you select this option, we will create a cash account automatically.",
    "createTechnicalAccountCurrency": "In what currency is this cash account?"
  }
}
